import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getClientTimelineHistory = () => {
    return httpClient.get(server.CLIENT_TIMELINE_HISTORY);
};
export const getgetClientTimelineHistoryByID = (id) => {
    return httpClient.get(server.CLIENT_TIMELINE_HISTORY + `/${id}`);
};

export const getgetClientTimelineHistoryShow = (query) => {
    return httpClient.get(server.CLIENT_TIMELINE_HISTORY + `/get-time-line-show`, query);
}
export const getgetTimelineDataDetail = (query) => {
    return httpClient.get(server.CLIENT_TIMELINE_HISTORY + `/get-time-detail`, query);
}
export const getgetClientTimelineHistoryShowVisibility = (query) => {
    return httpClient.get(server.CLIENT_TIMELINE_HISTORY + `/get-time-line-show-visibility`, query);
}
export const creategetClientTimelineHistory = (data) => {
    return httpClient.post(server.CLIENT_TIMELINE_HISTORY + `/`, data);
};


export const updategetClientTimelineHistory = (id, data) => {
    return httpClient.put(server.CLIENT_TIMELINE_HISTORY + `/${id}`, data);
};
export const deletegetClientTimelineHistory = (id) => {
    return httpClient.delete(server.CLIENT_TIMELINE_HISTORY + `/${id}`);
}